module.exports = "/assets/images/b60da1d4c7e0e25771af7dee0722c1a9.svg";